<template>
    <Form @submit="onSubmit" v-slot="{ errors }" @invalid-submit="onInvalidSubmit">
        <div class="flex flex-col">
            <div>
                <div class="mb-10  last:mb-0">
                    <h2 class="text-dark-550  dark:text-white font-bold flex items-center text-xl">
                        <i class="w-2 h-2 bg-gray-350 dark:bg-white ml-2 rounded-full "></i>
                        {{ state }}
                    </h2>
                    <div class="divider col-span-full mt-0 mb-3"></div>
                    <div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 1">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Type') }} <span class="text-error">*</span>
                                </label>
                                <Field as="select" v-model="clue.type" rules="required"
                                    :class="{ 'input-error': errors.type }" class="select" name="type">
                                    <option value="genuine">{{ __('Genuine') }}</option>
                                    <option value="legal">{{ __('Legal') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Nickname') }}
                                </label>
                                <Field as="select" v-model="clue.salutation"
                                    :class="{ 'input-error': errors.salutation }" class="select" name="salutation">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in salutationTypes" :value="item">{{
                                        __(item) }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Full name') }} <span class="text-error">*</span>
                                </label>
                                <Field v-model="clue.name" rules="required"
                                    :class="{ 'input-error': errors.name }" class="input" type="text"
                                    name="name" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Status') }}
                                </label>
                                <Field as="select" v-model="clue.status" :class="{ 'input-error': errors.status }"
                                    class="select" name="status">
                                    <option v-for="item in statusTypes" :value="item">{{
                                        __(item.replace('_', ' ').capitalize()) }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Reference to') }}
                                </label>
                                <Field as="select" v-model="clue.report_to_id"
                                    :class="{ 'input-error': errors.report_to_id }" class="select" name="report_to_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.users" :value="item.id">{{item.name }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Lead source') }}
                                </label>
                                <Field as="select" v-model="clue.lead_source_id"
                                    :class="{ 'input-error': errors.lead_source_id }" class="select" name="lead_source_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.lead_sources" :value="item.id">{{item.title }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex justify-between">
                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium"
                                        for="">
                                        {{ __('Phone number') }}
                                    </label>
                                    <button @click="addNumber" type="button"
                                        class="btn btn-xs btn-link no-underline">{{ __('Adding')
                                        }}</button>
                                </div>
                                <div class="flex mb-2" v-for="(info, index) in clue.numbers">
                                    <div class="join w-full">
                                        <select class="select join-item w-auto" v-model="info.type">
                                            <option v-for="item in numberTypes" :value="item">
                                                {{ __(item.capitalize()) }}
                                            </option>
                                        </select>
                                    <Field class="input join-item" :validateOnBlur="false" :validateOnInput="true" v-model="info.value"  :class="{ 'input-error': errors[`numbers[${index}]`] }" :name="`numbers[${index}]`" rules="numeric"  dir="ltr" @input="checkNumber('clue',$event,clue.id)" type="tel" inputmode="numeric" />

                                    </div>
                                    <div class="mr-1 flex flex-col justify-center">
                                        <button type="button" v-if="clue.numbers.length > 1"
                                            class="btn btn-xs btn-error btn-circle" @click="removeNumber(index)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                                <small class="text-error">{{ message }}</small>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex justify-between">
                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium"
                                        for="">
                                        {{ __('Email') }}
                                    </label>
                                    <button @click="addEmail" class="btn btn-xs btn-link no-underline" type="button">{{
                                        __('Adding')
                                        }}</button>
                                </div>
                                <div class="flex mb-2" v-for="(info, index) in clue.emails">
                                    <input class="input join-item" v-model="info.value" />

                                    <div class="mr-1 flex flex-col justify-center">
                                        <button type="button" v-if="clue.emails.length > 1"
                                            class="btn btn-xs btn-error btn-circle" @click="removeEmail(index)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Account name') }}
                                </label>
                                <Field v-model="clue.account_name" :class="{ 'input-error': errors.account_name }"
                                    class="input" type="text" name="account_name" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Website') }}
                                </label>
                                <Field v-model="clue.website" :class="{ 'input-error': errors.website }" class="input"
                                    type="text" name="website" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('National number') }}
                                </label>
                                <Field v-model="clue.national_number" :class="{ 'input-error': errors.national_number }"
                                    class="input" type="number" name="national_number" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Side') }}
                                </label>
                                <Field v-model="clue.title" :class="{ 'input-error': errors.title }" class="input"
                                    type="text" name="title" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Ready message') }}
                                </label>
                                <Field as="select" v-model="clue.message_id" :class="{ 'input-error': errors.message_id }"
                                    class="select" name="message_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.messages" :value="item.id">{{
                                    item.title }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col col-span-full">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Description') }}
                                </label>
                                <Field as="textarea" v-model="clue.description"
                                    :class="{ 'input-error': errors.description }" class="textarea" type="text"
                                    name="description" />
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 2">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('The level of attractiveness') }}
                                </label>
                                <Field as="select" v-model="clue.rating" :class="{ 'input-error': errors.rating }"
                                    class="select" name="rating">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option value="hot">{{ __('Hot') }}</option>
                                    <option value="warm">{{ __('Warm') }}</option>
                                    <option value="cold">{{ __('Cold') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Campaign') }}
                                </label>
                                <Field as="select" v-model="clue.campaign_id"
                                    :class="{ 'input-error': errors.campaign_id }" class="select" name="campaign_id">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.campaigns" :value="item.id">{{ item.name }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Industry') }}
                                </label>
                                <Field as="select" v-model="clue.industry" @change="changeIndustry"
                                    :class="{ 'input-error': errors.industry }" class="select" name="industry">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.industries" :value="item.title">{{ item.title }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Sub industry') }}
                                </label>
                                <Field as="select" v-model="clue.subindustry"
                                    :class="{ 'input-error': errors.subindustry }" class="select" name="subindustry">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in industries" :value="item.title">{{ item.title }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Referred by') }}
                                </label>
                                <Field v-model="clue.refered_by" :class="{ 'input-error': errors.refered_by }"
                                    class="input" type="text" name="refered_by" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Date of birth') }}
                                </label>
                                <DatePicker v-model="clue.birthdate" name="birthdate" inputClass="input" type="date" />

                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Economic code') }}
                                </label>
                                <Field v-model="clue.tax_id" :class="{ 'input-error': errors.tax_id }" class="input"
                                    type="text" name="tax_id" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Registration number') }}
                                </label>
                                <Field v-model="clue.registration_number"
                                    :class="{ 'input-error': errors.registration_number }" class="input" type="number"
                                    name="registration_number" />
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 3">
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Country') }}
                                </label>
                                <Field as="select" v-model="clue.billing.country"
                                    :class="{ 'input-error': errors.billing_country }" class="select"
                                    name="billing_country">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option :value="__('Iran')">{{ __('Iran') }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('State') }}
                                </label>
                                <Field as="select" v-model="clue.billing.state" @change="changeState"
                                    :class="{ 'input-error': errors.billing_state }" class="select" name="billing_state">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in meta.states" :value="item.name">{{ item.name }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('City') }}
                                </label>
                                <Field as="select" v-model="clue.billing.city" @change="changeCity"
                                    :class="{ 'input-error': errors.billing_city }" class="select" name="billing_city">
                                    <option value="">{{ __('Select...') }}</option>
                                    <option v-for="item in cities" :value="item.name">{{ item.name }}</option>
                                </Field>
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Postal Code') }}
                                </label>
                                <Field v-model="clue.billing.postalcode"
                                    :class="{ 'input-error': errors.billing_postalcode }" class="input" type="number"
                                    name="billing_postalcode" />
                            </div>
                            <div class="flex flex-col">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('Address') }}
                                </label>
                                <Field v-model="clue.billing.street" :class="{ 'input-error': errors.billing_street }"
                                    class="input" type="text" name="billing_street" />
                            </div>
                            <div class="flex items-end">
                                <div class="flex flex-col flex-1">
                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium"
                                        for="">
                                        {{ __('Latitude') }}
                                    </label>
                                    <Field v-model="clue.billing.latitude"
                                        :class="{ 'input-error': errors.billing_latitude }" class="input" type="number"
                                        name="billing_latitude" />
                                </div>
                                <div class="flex flex-col mr-1 flex-1">
                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium"
                                        for="">
                                        {{ __('Longitude') }}
                                    </label>
                                    <Field v-model="clue.billing.longitude"
                                        :class="{ 'input-error': errors.billing_longitude }" class="input" type="number"
                                        name="billing_longitude" />
                                </div>
                                <label class="btn btn-primary mr-1" for="modal-map" @click="setMap">
                                    <MapPinIcon class="w-5 h-5" />
                                </label>
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 4">
                            <div class="flex flex-col" v-for="item in socialTypes">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __(item.capitalize()) }}
                                </label>
                                <Field v-model="clue.social[item]" class="input" type="text" :name="item" />
                            </div>
                        </div>
                        <div class="grid md:grid-cols-2 grid-cols-1 md:gap-x-6 gap-y-4" v-show="step == 5">
                            <div class="flex flex-col col-span-full">
                                <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                    {{ __('File') }}
                                </label>
                                <Field class="file-input pr-0" @change="addAttachment($event,'attachment')" type="file" name="file" />
                            </div>
                            <div class="overflow-x-auto col-span-full">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{{ __('File title') }}</th>
                                            <th>{{ __('File type') }}</th>
                                            <th>{{ __('Status') }}</th>
                                            <th>{{ __('Action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in clue.attachments">
                                            <th>{{ index + 1 }}</th>
                                            <th>{{ item.name }}</th>
                                            <td>{{ item.mime_type }}</td>
                                            <td>
                                                <div v-if="isNumeric(item.status)">
                                                    <progress class="progress progress-info w-16" :value="item.status" max="100"></progress> <span class="mr-0.5 inline-block w-4">{{ item.status + '%' }}</span>
                                                </div>
                                                <div v-else>{{ __(item.url ? 'Uploaded' : 'Uploading') }}</div>
                                            </td>
                                            <td>
                                    <button @click="removeFile(clue.attachments,index)" type="button"
                                        class="btn btn-outline btn-error btn-sm">
                                        {{ __('Delete') }}
                                    </button>
                                </td>
                                        </tr>
                                    </tbody>
                                    <tfoot class="text-center" v-if="!clue.attachments.length">
                                        <tr>
                                            <td colspan="5">{{ __('No file found to display') }}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider h-auto w-full"></div>
            <div class="text-end">
                <button type="submit" class="btn btn-primary px-6 mr-2">{{
                    __('Save Changes')
                }}</button>
            </div>
        </div>
    </Form>
    <input type="checkbox" id="modal-map" class="modal-toggle" />
    <div class="modal">
        <div class="modal-box max-w-5xl">
            <div class="h-[600px]">
            <l-map ref="map" v-model:zoom="zoom" :center="centerLatLng" v-if="showMap" :use-global-leaflet="false" @update:center="updateCenter">
                <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base"
                    name="OpenStreetMap"></l-tile-layer>
                    <l-marker :lat-lng="markerLatLng"></l-marker>
            </l-map>
        </div>
            <div class="modal-action justify-between items-center">
                <div>
                    <label class="btn btn-error ml-2 btn-sm" for="modal-map">{{ __('Cancel') }}</label>
                    <label class="btn btn-success btn-sm text-white" for="modal-map" @click="setLocation">{{ __('Save')
                        }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

import DatePicker from 'vue3-persian-datetime-picker'
import { LMap, LTileLayer,LMarker } from "@vue-leaflet/vue-leaflet";
import { Field, Form } from "vee-validate";
import { MapPinIcon } from "@heroicons/vue/24/outline";
const emit = defineEmits(['setStep']);
const props = defineProps(['clue','meta','step','state']);
const showMap = ref(false);
const zoom = ref(11);
const centerLatLng = ref([35.7029075623, 51.3497581482]);
const markerLatLng = ref(centerLatLng.value);
const numberTypes = ['mobile','office', 'fax', 'factory', 'home', 'whatsapp', 'other'];
const salutationTypes = ['Mr', 'Ms', 'Eng', 'Dr', 'Prof', 'Mr.Dr', 'Ms.Dr', 'Mr.Eng', 'Ms.Eng'];
const statusTypes = ['new', 'assigned', 'in_process', 'converted', 'recycled', 'dead'];
const socialTypes = ['linkedin', 'instagram', 'blog', 'facebook', 'twitter', 'telegram'];
const { uploadFile, removeFile,clue, getCities,storeClue,updateClue,getSubIndustries,route,message,checkNumber,industries, cities} = useDashboard();
Object.assign(clue,props.clue);
if (clue.industry) getSubIndustries(clue.industry,false);
if (clue.billing.state) getCities(clue.billing.state, clue.billing.city);
watch(industries,(value) => {
    if (clue.subindustry && !value.some(item => item.title == clue.subindustry)) industries.value.push({ title: clue.subindustry })
})
const addNumber = () => clue.numbers = [...clue.numbers,{ type: 'office', value: '' }];
const addEmail = () => clue.emails = [...clue.emails,{ value: '' }];
const removeNumber = (i) => clue.numbers = clue.numbers.filter((item, index) => index != i);
const removeEmail = (i) => clue.emails = clue.emails.filter((item, index) => index != i);
const updateCenter = (latlng) => markerLatLng.value = [latlng.lat,latlng.lng];
const addAttachment = (event,type) => {
    clue.attachments = [...clue.attachments,{title: event.target.files[0].name,type: 'attachment',status: 'uploading'}];
    uploadFile(event,type,clue.attachments[clue.attachments.length - 1]);
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
const changeIndustry = () => {
    clue.subindustry = '';
    getSubIndustries(clue.industry);
}
const changeState = () => {
    clue.billing.city = '';
    clue.billing.latitude = '';
    clue.billing.longitude = '';
    getCities(clue.billing.state);
}
const changeCity = () => {
    clue.billing.latitude = '';
    clue.billing.longitude = '';
}
const setMap = () => {
    showMap.value = true;
    const billing = clue.billing;
    if(billing.latitude && billing.longitude) centerLatLng.value = [billing.latitude,billing.longitude];
    else if(cities.value.find(item => billing.city == item.name)) {
        const city = cities.value.find(item => billing.city == item.name);
        centerLatLng.value = [city.latitude,city.longitude];
    }else if(props.meta.states.find(item => billing.state == item.name)) {
        const state = props.meta.states.find(item => billing.state == item.name);
        centerLatLng.value = [state.latitude,state.longitude];
    }
    markerLatLng.value = centerLatLng.value;
}
const setLocation = () => Object.assign(clue.billing, { latitude: markerLatLng.value[0], longitude: markerLatLng.value[1] })
const onSubmit = () => {
    if(route.params.id) updateClue();
    else storeClue();
}
const setStep = (step) => emit('setStep',step);
const onInvalidSubmit = ({ errors }) => {
   setStep(1);
};
</script>
